import React from 'react';
import "./ConfirmationModal.scss"
import closeIcon from '../../Assets/images/modal-close.svg';

const ConfirmationModal = ({
    id,
    show,
    title,
    message,
    confirmText,
    cancelText,
    onConfirm,
    onCancel
}) => {
    return (
        <div className={`modal fade ${show ? 'show d-block' : ''}`} id={id} tabIndex="-1" aria-labelledby={`${id}Label`} aria-hidden={!show} style={{ backgroundColor: show ? 'rgba(0, 0, 0, 0.15)' : 'transparent' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content setm-content">
                    <div className="modal-body stem-body">
                        <div className="add-modal">
                            <div className="am-head del-head">
                                <h2>{title}</h2>
                                <button type="button" onClick={onCancel}>
                                    <img src={closeIcon} alt="Close" />
                                </button>
                            </div>
                            <div className="am-content">
                                <div className="del-content">
                                    <p>{message}</p>
                                    <div className="del-btns">
                                        <a className="del-no" href="#" onClick={(e) => { e.preventDefault(); onCancel(); }}>
                                            {cancelText}
                                        </a>
                                        <a className="del-yes" href="#" onClick={(e) => { e.preventDefault(); onConfirm(); }}>
                                            {confirmText}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
